import type { Root } from './prototypeTypes';

export interface AiHistoryReturnState {
	filter: 'completed' | 'inprogress';
	search: string;
}

interface AiHistoryReturnHolder {
	__aiHistoryReturnState?: AiHistoryReturnState;
	__aiHistoryReturnRequested?: boolean;
}

function holder(root: Root): AiHistoryReturnHolder {
	return root as unknown as AiHistoryReturnHolder;
}

/** Remember the exact History projection from which a job detail was opened. */
export function captureAiHistoryReturnState(root: Root): void {
	const activeFilter = root.querySelector<HTMLElement>('#aiFilterTabs .category-pill.active');
	const action = activeFilter?.dataset.protoClick ?? '';
	const search = root.querySelector<HTMLInputElement>('#aiSearchInput')?.value.trim() ?? '';
	holder(root).__aiHistoryReturnState = {
		filter: action.includes('inprogress') ? 'inprogress' : 'completed',
		search,
	};
}

/** Mark the next AI Create navigation as a detail Back navigation. */
export function requestAiHistoryReturn(root: Root): void {
	holder(root).__aiHistoryReturnRequested = true;
}

/** Consume a requested return once; ordinary AI Create navigation still resets. */
export function consumeRequestedAiHistoryReturnState(root: Root): AiHistoryReturnState | null {
	const state = holder(root);
	if (!state.__aiHistoryReturnRequested) return null;
	state.__aiHistoryReturnRequested = false;
	const snapshot = state.__aiHistoryReturnState ?? null;
	delete state.__aiHistoryReturnState;
	return snapshot;
}
